var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"primary-btn",class:_vm.clsName,on:{"click":_vm.clickHandler}},[(_vm.icon)?_c('div',{staticClass:"round-btn-icon",style:({ background: _vm.iconBg })}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }